import { render, staticRenderFns } from "./AddPlaneDialog.vue?vue&type=template&id=36a5061d&scoped=true&"
import script from "./AddPlaneDialog.vue?vue&type=script&lang=js&"
export * from "./AddPlaneDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a5061d",
  null
  
)

export default component.exports